import {PlantViewToggle} from '@hconnect/common/components'
import {PlantViewOption, PlantViewOptions} from '@hconnect/common/consts'
import {getButtonOutlineWhite} from '@hconnect/common/styles'
import {TimeZone} from '@hconnect/uikit'
import {
  DateRangePicker,
  ExpandCollapseButton,
  buttonOnBlueSx,
  mergeSxs
} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {getRcfaComplianceQuickSelectionItems} from '../utils'

const expandButtonMinWidthSx = {minWidth: {xs: '100%', sm: '150px'}}

type Props = {
  timeRange: string
  setTimeRange: (param: string) => void
  allExpanded: boolean
  toggleExpandCollapseAll: () => void
  plantView: PlantViewOption
  setPlantView: (value: PlantViewOption) => void
  timezone: TimeZone
  isMobile?: boolean
  // true when hosted on the legacy blue surface; false (default) on the Suite grey surface
  inverted?: boolean
}

export const RcfaComplianceHeaderActions = (props: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {timezone, isMobile, inverted = false} = props
  const expandCollapseButtonSx = mergeSxs(
    inverted ? buttonOnBlueSx : getButtonOutlineWhite,
    expandButtonMinWidthSx
  )

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      <DateRangePicker
        timeRangeParam={props.timeRange}
        onTimeRangeParamChange={props.setTimeRange}
        singleDateSwitchLabel={t('quickSelection.pickSingleDate')}
        selectionItems={getRcfaComplianceQuickSelectionItems(t, timezone)}
        timezone={timezone}
        fullWidth={!!isMobile}
        isContrastMode={inverted}
      />
      {props.plantView === PlantViewOptions.REGIONAL_STRUCTURE && !isMobile && (
        <ExpandCollapseButton
          sx={expandCollapseButtonSx}
          collapseLabel={t('button.collapseAll')}
          expandLabel={t('button.expandAll')}
          expanded={props.allExpanded}
          onClick={props.toggleExpandCollapseAll}
          data-test-id="expand-collapse-button"
        />
      )}
      <PlantViewToggle
        value={props.plantView}
        t={t}
        onChange={props.setPlantView}
        fullWidth={!!isMobile}
        isContrastMode={inverted}
      />
    </Stack>
  )
}
